import { Field, FieldProps, getIn } from 'formik';
import { ReactNode } from 'react';

import { Input } from '../../components';
import { InputProps } from 'antd/lib/input';

interface Props {
  name: string;
  label?: ReactNode;
  placeholder?: string;
  type?: 'password' | 'text';
  size?: InputProps['size'];
}

export default function InputField({ name, type, size, ...bag }: Props) {
  return (
    <Field name={name}>
      {({ field, form: { errors } }: FieldProps) => (
        <div>
          {type === 'password' ? (
            <Input.Password error={getIn(errors, name)} size={size} {...field} {...bag} />
          ) : (
            <Input type={type} error={getIn(errors, name)} size={size} {...field} {...bag} />
          )}
        </div>
      )}
    </Field>
  );
}
